import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { BootstrapVue } from 'bootstrap-vue';
import App from './App.vue';
import LocalizedRouter from './router';
import store from './store';
// import './registerServiceWorker';

import 'bootstrap-vue/dist/bootstrap-vue.css';

import 'ott-cwl/dist/ott-cwl/ott-cwl.css';
import { applyPolyfills, defineCustomElements } from 'ott-cwl/loader';

Vue.config.productionTip = false;

// Tell Vue to ignore all components defined in our custom library
// and bind the custom elements to the window object
Vue.config.ignoredElements = [/ott-\w*/];
applyPolyfills().then(() => {
  defineCustomElements();
});

let pageLocale = 'en';
if (document && document.documentElement && document.documentElement.lang) {
  const htmlLocale = document.documentElement.lang;
  if (typeof htmlLocale !== 'undefined' && htmlLocale !== null
      && htmlLocale.includes('fr')) {
    pageLocale = 'fr';
  }
}
// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);
// Configure the i18n strings.
Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: pageLocale,
});

const router = new LocalizedRouter(i18n);

const app = new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');


